<template>
  <div id="search">
<headers></headers>

<div class="row widu" style="margin:0 auto;margin-top:10px">
<div class="span6">
<ul class="breadcrumb">
<span style="color:#999">当前位置：</span>
<li>
<a href="/">网站首页</a> <span class="divider">></span>
</li>
<li class="active" style="color:#999">裸钻搜索 
<span v-if="hl" style="margin-left:30px;color:#666"> 天然钻汇率 {{hl}} 培育钻汇率 {{mhl}}</span> 
<span style="margin-left:10px;color:red">{{tips}}</span>
</li>
</ul>
</div>
</div>



<div style="height:2px"></div>
<div style="margin:0 auto;line-height:30px" class="widu">


<form class="form-horizontal" action="" method="post">


 <table   height="350"  align="center"    class="Tab"  border="1"  








 style="border-collapse:collapse;width:1424px;border:1px solid #ccc"> 
              <tbody> 

               <tr bgcolor="#ffffff"> 
                <td width="71" height="48" align="center"><strong>形状<br /> Shape </strong></td> 
                <td height="48" colspan="6" align="left">

                 <table width="48" height="48" border="0" style="padding:0px"   class="xz"  v-bind:class="{ 'xz_a': shape=='圆形' }" id="xz1" v-on:click="setShape('圆形')"  > 
                  <tbody>
                   <tr> 
                    <td align="center"><img src="../assets/images/yx.jpg" width="46" height="48" /></td> 
                   </tr> 
                  </tbody>
                 </table> 
                 <table width="48" height="48" border="0"   class="xz" id="xz2" v-on:click="setShape('公主方')"  v-bind:class="{ 'xz_a': shape=='公主方' }" > 
                  <tbody>
                   <tr> 
                    <td align="center"><img src="../assets/images/yx2.jpg" width="46" height="48" /></td> 
                   </tr> 
                  </tbody>
                 </table> 
                 <table width="48" height="48" border="0"   class="xz" id="xz3" v-on:click="setShape('椭圆形')" v-bind:class="{ 'xz_a': shape=='椭圆形' }"> 
                  <tbody>
                   <tr> 
                    <td align="center"><img src="../assets/images/yx3.jpg" width="46" height="48" /></td> 
                   </tr> 
                  </tbody>
                 </table> 
                 <table width="48" height="48" border="0"  class="xz"  id="xz4" v-on:click="setShape('梨形')"   v-bind:class="{ 'xz_a': shape=='梨形' }" > 
                  <tbody>
                   <tr> 
                    <td align="center"><img src="../assets/images/yx4.jpg" width="46" height="48" /></td> 
                   </tr> 
                  </tbody>
                 </table>
                 <table width="48" height="48" border="0"  class="xz"  id="xz5" v-on:click="setShape('祖母绿')"   v-bind:class="{ 'xz_a': shape=='祖母绿' }" > 
                  <tbody>
                   <tr> 
                    <td align="center"><img src="../assets/images/yx5.jpg" width="46" height="48" /></td> 
                   </tr> 
                  </tbody>
                 </table>
                 <table width="48" height="48" border="0"   class="xz" id="xz6" v-on:click="setShape('心形')" v-bind:class="{ 'xz_a': shape=='心形' }"> 
                  <tbody>
                   <tr> 
                    <td align="center"><img src="../assets/images/yx6.jpg" width="46" height="48" /></td> 
                   </tr> 
                  </tbody>
                 </table> 
                 <table width="48" height="48" border="0"   class="xz" id="xz7" v-on:click="setShape('橄榄形')" v-bind:class="{ 'xz_a': shape=='橄榄形' }"> 
                  <tbody>
                   <tr> 
                    <td align="center"><img src="../assets/images/yx7.jpg" width="46" height="48" /></td> 
                   </tr> 
                  </tbody>
                 </table>
                 <table width="48" height="48" border="0"   class="xz" id="xz8" v-on:click="setShape('雷迪恩')" v-bind:class="{ 'xz_a': shape=='雷迪恩' }"> 
                  <tbody>
                   <tr> 
                    <td align="center"><img src="../assets/images/yx8.jpg" width="46" height="48" /></td> 
                   </tr> 
                  </tbody>
                 </table>
                 <table width="48" height="48" border="0"   class="xz" id="xz9" v-on:click="setShape('垫形')" v-bind:class="{ 'xz_a': shape=='垫形' }"> 
                  <tbody>
                   <tr> 
                    <td align="center"><img src="../assets/images/yx9.jpg" width="46" height="48" /></td> 
                   </tr> 
                  </tbody>
                 </table>
                 <table width="48" height="48" border="0"   class="xz" id="xz10" v-on:click="setShape('三角形')" v-bind:class="{ 'xz_a': shape=='三角形' }"> 
                  <tbody>
                   <tr> 
                    <td align="center"><img src="../assets/images/yx10.jpg" width="46" height="48" /></td> 
                   </tr> 
                  </tbody>
                 </table> 
                

</td>
</tr>






    <tr bgcolor="#ffffff"> 
                <td height="20" align="center"><strong>颜色<br /> Color</strong></td> 
                <td height="20" colspan="5" align="left">
                 <table width="38" height="38" border="0"   class="ys" id="ys_D" v-on:click="setColor('D')"   v-bind:class="{ 'ys_a': color.indexOf('D')>-1 }"> 
                  <tbody>
                   <tr> 
                    <td align="center">D</td> 
                   </tr> 
                  </tbody>
                 </table> 
                 <table width="38" height="38" border="0"   class="ys" id="ys_E" v-on:click="setColor('E')"   v-bind:class="{ 'ys_a': color.indexOf('E')>-1 }"> 
                  <tbody>
                   <tr> 
                    <td align="center">E</td> 
                   </tr> 
                  </tbody>
                 </table> 
                 <table width="48" height="28" border="0"   class="ys" id="ys_F" v-on:click="setColor('F')"   v-bind:class="{ 'ys_a': color.indexOf('F')>-1 }"> 
                  <tbody>
                   <tr> 
                    <td align="center">F</td> 
                   </tr> 
                  </tbody>
                 </table> 
                 <table width="48" height="28" border="0"   class="ys" id="ys_G" v-on:click="setColor('G')"   v-bind:class="{ 'ys_a': color.indexOf('G')>-1 }"> 
                  <tbody>
                   <tr> 
                    <td align="center">G</td> 
                   </tr> 
                  </tbody>
                 </table> 
                 <table width="48" height="28" border="0"   class="ys" id="ys_H" v-on:click="setColor('H')"   v-bind:class="{ 'ys_a': color.indexOf('H')>-1 }"> 
                  <tbody>
                   <tr> 
                    <td align="center">H</td> 
                   </tr> 
                  </tbody>
                 </table> 
                 <table width="48" height="28" border="0"   class="ys" id="ys_I" v-on:click="setColor('I')"   v-bind:class="{ 'ys_a': color.indexOf('I')>-1 }"> 
                  <tbody>
                   <tr> 
                    <td align="center">I</td> 
                   </tr> 
                  </tbody>
                 </table> 
                 <table width="48" height="28" border="0"   class="ys" id="ys_J" v-on:click="setColor('J')"   v-bind:class="{ 'ys_a': color.indexOf('J')>-1 }"> 
                  <tbody>
                   <tr> 
                    <td align="center">J</td> 
                   </tr> 
                  </tbody>
                 </table> 
                 <table width="48" height="28" border="0"   class="ys" id="ys_K" v-on:click="setColor('K')"   v-bind:class="{ 'ys_a': color.indexOf('K')>-1 }"> 
                  <tbody>
                   <tr> 
                    <td align="center">K</td> 
                   </tr> 
                  </tbody>
                 </table> 
                 <table width="48" height="28" border="0"   class="ys" id="ys_L" v-on:click="setColor('L')"   v-bind:class="{ 'ys_a': color.indexOf('L')>-1 }"> 
                  <tbody>
                   <tr> 
                    <td align="center">L</td> 
                   </tr> 
                  </tbody>
                 </table> 
                 <table width="48" height="28" border="0"   class="ys" id="ys_M" v-on:click="setColor('M')"   v-bind:class="{ 'ys_a': color.indexOf('M')>-1 }"> 
                  <tbody>
                   <tr> 
                    <td align="center">M</td> 
                   </tr> 
                  </tbody>
                 </table> 

                 <table width="48" height="28" border="0"   class="ys" id="ys_N" v-on:click="setColor('N')"  v-bind:class="{ 'ys_a': color.indexOf('N')>-1 }"> 
                  <tbody>
                   <tr> 
                    <td align="center">N</td>
                   </tr> 
                  </tbody>
                 </table>

                 <table width="48" height="28" border="0"   class="ys" id="ys_BLUE" v-on:click="setColor('BLUE')"  v-bind:class="{ 'ys_a': color.indexOf('BLUE')>-1 }"> 
                  <tbody>
                   <tr> 
                    <td align="center">BLUE</td>
                   </tr> 
                  </tbody>
                 </table>

                 <table width="48" height="28" border="0"   class="ys" id="ys_PINK" v-on:click="setColor('PINK')"  v-bind:class="{ 'ys_a': color.indexOf('PINK')>-1 }"> 
                  <tbody>
                   <tr> 
                    <td align="center">PINK</td>
                   </tr> 
                  </tbody>
                 </table>

                 <table width="48" height="28" border="0"   class="ys" id="ys_YELLOW" v-on:click="setColor('YELLOW')"  v-bind:class="{ 'ys_a': color.indexOf('YELLOW')>-1 }"> 
                  <tbody>
                   <tr> 
                    <td align="center">YELLOW</td>
                   </tr> 
                  </tbody>
                 </table>

                 <table width="48" height="28" border="0"   class="ys" id="ys_GREEN" v-on:click="setColor('GREEN')"  v-bind:class="{ 'ys_a': color.indexOf('GREEN')>-1 }"> 
                  <tbody>
                   <tr> 
                    <td align="center">GREEN</td>
                   </tr> 
                  </tbody>
                 </table>
                 
                 </td> 
               </tr> 






                 <tr bgcolor="#ffffff"> 
                <td height="4" align="center"><strong>净度<br /> Clarity</strong></td> 
                <td height="4" colspan="5" align="left">
                 <table width="48" height="28" border="0"   class="ys" id="jd_FL" v-on:click="setClarity('FL')"  v-bind:class="{ 'ys_a': clarity.indexOf('FL')>-1 }"> 
                  <tbody>
                   <tr> 
                    <td align="center">FL</td> 
                   </tr> 
                  </tbody>
                 </table> 
                 <table width="48" height="28" border="0"   class="ys" id="jd_IF" v-on:click="setClarity('IF')"  v-bind:class="{ 'ys_a': clarity.indexOf('IF')>-1 }"> 
                  <tbody>
                   <tr> 
                    <td align="center">IF</td> 
                   </tr> 
                  </tbody>
                 </table> 
                 <table width="48" height="28" border="0"   class="ys" id="jd_VVS1" v-on:click="setClarity('VVS1')"  v-bind:class="{ 'ys_a': clarity.indexOf('VVS1')>-1 }"> 
                  <tbody>
                   <tr> 
                    <td align="center">VVS1</td> 
                   </tr> 
                  </tbody>
                 </table> 
                 <table width="48" height="28" border="0"   class="ys" id="jd_VVS2"  v-on:click="setClarity('VVS2')"  v-bind:class="{ 'ys_a': clarity.indexOf('VVS2')>-1 }"> 
                  <tbody>
                   <tr> 
                    <td align="center">VVS2</td> 
                   </tr> 
                  </tbody>
                 </table> 
                 <table width="48" height="28" border="0"   class="ys" id="jd_VS1" v-on:click="setClarity('VS1')"  v-bind:class="{ 'ys_a': clarity.indexOf('VS1')>-1 }"> 
                  <tbody>
                   <tr> 
                    <td align="center">VS1</td> 
                   </tr> 
                  </tbody>
                 </table> 
                 <table width="48" height="28" border="0"   class="ys" id="jd_VS2" v-on:click="setClarity('VS2')"  v-bind:class="{ 'ys_a': clarity.indexOf('VS2')>-1 }"> 
                  <tbody>
                   <tr> 
                    <td align="center">VS2</td> 
                   </tr> 
                  </tbody>
                 </table> 
                 <table width="48" height="28" border="0"   class="ys" id="jd_SI1" v-on:click="setClarity('SI1')"  v-bind:class="{ 'ys_a': clarity.indexOf('SI1')>-1 }"> 
                  <tbody>
                   <tr> 
                    <td align="center">SI1</td> 
                   </tr> 
                  </tbody>
                 </table> 
                 <table width="48" height="28" border="0"   class="ys" id="jd_SI2" v-on:click="setClarity('SI2')"  v-bind:class="{ 'ys_a': clarity.indexOf('SI2')>-1}"> 
                  <tbody>
                   <tr> 
                    <td align="center">SI2</td> 
                   </tr> 
                  </tbody>
                 </table> 
                 <table width="48" height="28" border="0"   class="ys" id="jd_I1" v-on:click="setClarity('I1')"  v-bind:class="{ 'ys_a': clarity.indexOf('I1')>-1 }"> 
                  <tbody>
                   <tr> 
                    <td align="center">I1</td> 
                   </tr> 
                  </tbody>
                 </table> 
                 <table width="48" height="28" border="0"   class="ys" id="jd_I2" v-on:click="setClarity('I2')"  v-bind:class="{ 'ys_a': clarity.indexOf('I2')>-1 }"> 
                  <tbody>
                   <tr> 
                    <td align="center">I2</td> 
                   </tr> 
                  </tbody>
                 </table> 
                 <table width="48" height="28" border="0"   class="ys" id="jd_I3"  v-on:click="setClarity('I3')"  v-bind:class="{ 'ys_a': clarity.indexOf('I3')>-1 }"> 
                  <tbody>
                   <tr> 
                    <td align="center">I3</td> 
                   </tr> 
                  </tbody>
                 </table></td> 
               </tr> 






                 <tr bgcolor="#ffffff"> 
                <td align="center"><strong>切工<br /> Cut</strong></td> 
                <td width="287" height="1" align="left">
                  <table width="48" height="28" border="0"   class="ys" id="qg_ID" v-on:click="setCut('ID')"  v-bind:class="{ 'ys_a': cut.indexOf('ID')>-1 }"> 
                  <tbody>
                   <tr> 
                    <td align="center">ID</td> 
                   </tr> 
                  </tbody>
                 </table> 
                 <table width="48" height="28" border="0"   class="ys" id="qg_EX" v-on:click="setCut('EX')"  v-bind:class="{ 'ys_a': cut.indexOf('EX')>-1 }"> 
                  <tbody>
                   <tr> 
                    <td align="center">EX</td> 
                   </tr> 
                  </tbody>
                 </table> 
                 <table width="48" height="28" border="0"   class="ys" id="qg_VG" v-on:click="setCut('VG')"  v-bind:class="{ 'ys_a': cut.indexOf('VG')>-1 }"> 
                  <tbody>
                   <tr> 
                    <td align="center">VG</td> 
                   </tr> 
                  </tbody>
                 </table> 
                 <table width="48" height="28" border="0"   class="ys" id="qg_GD" v-on:click="setCut('GD')"  v-bind:class="{ 'ys_a': cut.indexOf('GD')>-1 }"> 
                  <tbody>
                   <tr> 
                    <td align="center">GD</td> 
                   </tr> 
                  </tbody>
                 </table> 
                  
                 </td> 
                <td align="center"><strong>所在地<br /> Country</strong></td> 
                <td width="244" align="left"> 
                 <table width="48" height="28" border="0"   class="ys  ys_a" > 
                  <tbody>
                   <tr> 
                    <td align="center"> CHINA</td> 
                   </tr> 
                  </tbody>
                 </table> 
                  </td> 
                <td width="62" align="center"><strong style="color:#999">咖奶绿<br /> BGM </strong></td> 
                <td width="263" align="left">
                 <table width="48" height="28" border="0"   class="ys" id="c1_1" style="color:#999;display:none"> 
                  <tbody>
                   <tr> 
                    <td align="center">待查 </td> 
                   </tr> 
                  </tbody>
                 </table>
                 <table width="48" height="28" border="0"   class="ys" id="c1_2" style="color:#999;display:none"> 
                  <tbody>
                   <tr> 
                    <td align="center">无</td> 
                   </tr> 
                  </tbody>
                 </table>
                 <table width="48" height="28" border="0"   class="ys" id="c1_3" style="color:#999;display:none"> 
                  <tbody>
                   <tr> 
                    <td align="center">轻</td> 
                   </tr> 
                  </tbody>
                 </table> 
                 <table width="48" height="28" border="0"   class="ys" id="c1_4" style="color:#999;display:none"> 
                  <tbody>
                   <tr> 
                    <td align="center">中</td> 
                   </tr> 
                  </tbody>
                 </table> 
                 <table width="48" height="28" border="0"   class="ys" id="c1_5" style="color:#999;display:none"> 
                  <tbody>
                   <tr> 
                    <td align="center">强</td> 
                   </tr> 
                  </tbody>
                 </table> </td> 
               </tr> 
               <tr bgcolor="#ffffff"> 
                <td align="center"><strong>抛光<br /> Polish</strong></td> 
                <td width="287" height="0" align="left">
                  <table width="48" height="28" border="0"   class="ys" id="pg_ID" v-on:click="setPolish('ID')"  v-bind:class="{ 'ys_a': polish.indexOf('ID')>-1 }"> 
                  <tbody>
                   <tr> 
                    <td align="center">ID</td> 
                   </tr> 
                  </tbody>
                 </table>  
                 <table width="48" height="28" border="0"   class="ys" id="pg_EX" v-on:click="setPolish('EX')"  v-bind:class="{ 'ys_a': polish.indexOf('EX')>-1 }"> 
                  <tbody>
                   <tr> 
                    <td align="center">EX</td> 
                   </tr> 
                  </tbody>
                 </table> 
                 <table width="48" height="28" border="0"   class="ys" id="pg_VG" v-on:click="setPolish('VG')"  v-bind:class="{ 'ys_a': polish.indexOf('VG')>-1 }"> 
                  <tbody>
                   <tr> 
                    <td align="center">VG</td> 
                   </tr> 
                  </tbody>
                 </table> 
                 <table width="48" height="28" border="0"   class="ys" id="pg_GD" v-on:click="setPolish('GD')"  v-bind:class="{ 'ys_a': polish.indexOf('GD')>-1 }"> 
                  <tbody>
                   <tr> 
                    <td align="center">GD</td> 
                   </tr> 
                  </tbody>
                 </table> 
                 </td> 
                <td width="54" align="center"><strong>证书类型<br /> Lab</strong></td> 
                <td align="left">
                 <table width="48" height="28" border="0"   class="ys" id="jdzs_GIA" v-on:click="setLab('GIA')"  v-bind:class="{ 'ys_a': lab.indexOf('GIA')>-1 }"> 
                  <tbody>
                   <tr> 
                    <td align="center">GIA</td> 
                   </tr> 
                  </tbody>
                 </table> 
                 <table width="48" height="28" border="0"   class="ys" id="jdzs_HRD" v-on:click="setLab('HRD')"  v-bind:class="{ 'ys_a': lab.indexOf('HRD')>-1 }"> 
                  <tbody>
                   <tr> 
                    <td align="center">HRD</td> 
                   </tr> 
                  </tbody>
                 </table> 
                 <table width="48" height="28" border="0"   class="ys" id="jdzs_IGI" v-on:click="setLab('IGI')"  v-bind:class="{ 'ys_a': lab.indexOf('IGI')>-1 }"> 
                  <tbody>
                   <tr> 
                    <td align="center">IGI</td> 
                   </tr> 
                  </tbody>
                 </table> 
                 </td> 
                <td colspan="2"></td>
               </tr> 
               <tr bgcolor="#ffffff"> 
                <td align="center"><strong>对称<br /> Symmetry</strong></td> 
                <td height="1" align="left">
                  <table width="48" height="28" border="0"   class="ys" id="dc_ID" v-on:click="setSym('ID')"  v-bind:class="{ 'ys_a': sym.indexOf('ID')>-1 }"> 
                  <tbody>
                   <tr> 
                    <td align="center">ID</td> 
                   </tr> 
                  </tbody>
                 </table> 
                 <table width="48" height="28" border="0"   class="ys" id="dc_EX" v-on:click="setSym('EX')"  v-bind:class="{ 'ys_a': sym.indexOf('EX')>-1 }"> 
                  <tbody>
                   <tr> 
                    <td align="center">EX</td> 
                   </tr> 
                  </tbody>
                 </table> 
                 <table width="48" height="28" border="0"   class="ys" id="dc_VG" v-on:click="setSym('VG')"  v-bind:class="{ 'ys_a': sym.indexOf('VG')>-1 }"> 
                  <tbody>
                   <tr> 
                    <td align="center">VG</td> 
                   </tr> 
                  </tbody>
                 </table> 
                 <table width="48" height="28" border="0"   class="ys" id="dc_GD" v-on:click="setSym('GD')"  v-bind:class="{ 'ys_a': sym.indexOf('GD')>-1 }"> 
                  <tbody>
                   <tr> 
                    <td align="center">GD</td> 
                   </tr> 
                  </tbody>
                 </table> 
                 </td> 
                <td align="center"><strong>荧光<br /> Fluor</strong></td> 
                <td height="1" align="left">
                 <table width="48" height="28" border="0"   class="ys" id="yg_N" v-on:click="setFlour('N')"  v-bind:class="{ 'ys_a': flour.indexOf('N')>-1 }"> 
                  <tbody>
                   <tr> 
                    <td align="center">N</td> 
                   </tr> 
                  </tbody>
                 </table> 
                 <table width="48" height="28" border="0"   class="ys" id="yg_F" v-on:click="setFlour('F')"  v-bind:class="{ 'ys_a': flour.indexOf('F')>-1 }"> 
                  <tbody>
                   <tr> 
                    <td align="center">F</td> 
                   </tr> 
                  </tbody>
                 </table> 
                 <table width="48" height="28" border="0"   class="ys" id="M" v-on:click="setFlour('M')"  v-bind:class="{ 'ys_a': flour.indexOf('M')>-1 }"> 
                  <tbody>
                   <tr> 
                    <td align="center">M</td> 
                   </tr> 
                  </tbody>
                 </table> 
                 <table width="48" height="28" border="0"   class="ys" id="yg_S" v-on:click="setFlour('S')"  v-bind:class="{ 'ys_a': flour.indexOf('S')>-1 }"> 
                  <tbody>
                   <tr> 
                    <td align="center">S</td> 
                   </tr> 
                  </tbody>
                 </table> 
                 <table width="48" height="28" border="0"   class="ys" id="yg_VS" v-on:click="setFlour('VS')"  v-bind:class="{ 'ys_a': flour.indexOf('VS')>-1}"> 
                  <tbody>
                   <tr> 
                    <td align="center">VS</td> 
                   </tr> 
                  </tbody>
                 </table></td>




                   <td align="center"><strong>类型<br /> Type</strong></td> 
                <td height="1" align="left">
                 <table width="48" height="28" border="0"   class="ys" id="type_N" v-on:click="setType('天然')"  v-bind:class="{ 'ys_a': type.indexOf('天然')>-1 }"> 
                  <tbody>
                   <tr> 
                    <td align="center">天然</td> 
                   </tr> 
                  </tbody>
                 </table> 
                 <table width="48" height="28" border="0"   class="ys" id="type_P" v-on:click="setType('培育')"  v-bind:class="{ 'ys_a': type.indexOf('培育')>-1 }"> 
                  <tbody>
                   <tr> 
                    <td align="center">培育</td> 
                   </tr> 
                  </tbody>
                 </table> 

                  <table width="48" height="28" border="0"   class="ys" id="type_P" v-on:click="setType('培育彩钻')"  v-bind:class="{ 'ys_a': type.indexOf('培育彩钻')>-1 }"> 
                  <tbody>
                   <tr> 
                    <td align="center">培育彩钻</td>
                   </tr> 
                  </tbody>
                 </table> 

                 </td> 
               




               </tr> 






                <tr bgcolor="#ffffff"> 
    <td align="center"><strong>重量范围<br /> Size(CT)</strong></td> 
    <td height="10" colspan="2" align="left">
                            <input name="size_from" v-model="size_from" type="text" id="size_from" value=""   size="6" style="padding-top:2px;text-align:center" /> 
                            <input name="size_to" v-model="size_to" type="text" id="size_to"   value=""   size="6" style="padding-top:2px;text-align:center" /> <span style="color:red">*</span>CT
    
                            选择范围：
                            <select v-model="size_range" @change="updateSizeInputs" style="padding-top:2px;text-align:center">
                              <option value="0.3-5.0">0.3-5.0</option>
                              <option value="0.3-0.39">0.3-0.39</option>
                              <option value="0.4-0.49">0.4-0.49</option>
                              <option value="0.5-0.59">0.5-0.59</option>
                              <option value="0.6-0.69">0.6-0.69</option>
                              <option value="0.7-0.79">0.7-0.79</option>
                              <option value="0.8-0.89">0.8-0.89</option>
                              <option value="0.9-0.99">0.9-0.99</option>
                              <option value="1.0-1.49">1.0-1.49</option>
                              <option value="1.5-1.99">1.5-1.99</option>
                              <option value="2.0-2.99">2.0-2.99</option>
                              <option value="3-3.99">3-3.99</option>
                              <option value="4-4.99">4-4.99</option>
                              <option value="5-9.99">5-9.99</option>
                              <option value="10ct以上">10ct以上</option>
                          </select>
    </td> 
    <td height="10" colspan="4" align="left"></td> 
</tr> 


</tbody> 
</table>

  <div class="form-group" style="height:10px">
  </div>

  <div class="form-group">
    <div class="col-sm-offset-2 col-sm-8" style="text-align:center">
      <button type="button" class="btn btn-primary" v-on:click="search()">
  <i class="fa fa-search"></i>
      钻石搜索</button>


    </div>
  </div>
</form>
</div>

<div v-if="diamonds">



<table border='1' style='border-collapse:collapse; table-layout: fixed;margin:0 auto' class="widu" cellspacing='0'>

<tr style="background:#FFF;border-bottom:1px solod #000;font-size:12px" >
<td>证书</td><td width="8%" style="text-align:right">编号</td><td width="7%">证书号</td><td width="3%">形状</td>
<td width="6%">
重量
<button v-on:click="sortBy('weight')">
  排序
</button>
</td>

<td width="5%">
颜色
</td>

<td width="5%">净度</td>
<td width="5%">国际报价</td><td width="5%">退点</td><td  width="6%">单价</td>
<td width="6%">金额</td>
<td width="3%">切工</td>
<td width="3%">抛光</td>
<td width="3%">对称</td>
<td width="3%">荧光</td>
<td  class="ov" width="3%">尺寸</td>
<td width="3%">台面</td>
<td width="3%">亭深</td>
<td width="5%">奶咖绿</td>
<td width="5%">分类</td>
<td width="5%">培育类型</td>
<td width="3%">
状态
</td>

<td width="3%">证书</td>
<td width="3%">图</td>
<td  v-if="userinfo.level==2" width="5%">---</td>
</tr>

<tr onmouseover="this.style.background='orange'" onmouseout="this.style.background=''" v-for="diamond in diamonds" :class="{on:diamond.id%2==0,off:diamond.id%2!=0}">
<td>{{diamond.jdzs}}</td>

<td style="text-align:right">{{diamond.hao}}</td>
<td>{{diamond.zsh}}</td>
<td>{{diamond.xz}}</td>
<td>{{diamond.zl}}</td>
<td>{{diamond.yc}}</td>
<td>{{diamond.jd}}</td>
<td v-html="diamond.mjbj"></td>
<td v-html="diamond.zk"></td>
<td  width="6%" v-html="diamond.dj"></td>
<td  width="6%" v-html="diamond.zje"></td>
<td>{{diamond.qg}}</td>
<td>{{diamond.pg}}</td>
<td>{{diamond.dc}}</td>
<td>{{diamond.yg}}</td>
<td><a :href="'#'" :title="diamond.cc" >..</a></td>
<td>{{format(diamond.tm)}}</td>
<td>{{format(diamond.sd)}}</td>
<td>{{diamond.bgm}}</td>
<td>{{diamond.type}}</td>
<td>{{diamond.pylx}}</td>
<td>{{diamond.zt}}</td>
<td>
<a v-bind:href="'https://www.gia.edu/CN/report-check?reportno=' + diamond.zsh" onclick="alert(diamond.zsh)" target='_blank'>证书</a>
</td>
<td>
<a v-bind:href="'http://file.giazh.com/' + diamond.zsh + '.jpg'" onclick="alert(diamond.zsh)" target='_blank'>图</a>
</td>
<td v-if="userinfo.level==2">
<div v-if="(diamond.cartszsh==null||(diamond.cartszsh!=null&&diamond.username!=username))&&diamond.is_delete==0">
<button style="white-space:nowrap;padding:0px 2px" v-on:click="addCart(diamond,diamond.id)" class="btn btn-default">购物车</button>
</div>
<div v-if="diamond.is_delete==1">已被订购</div>
</td>
</tr>
</table>

</div>



<div style="clear:both;"></div>
   <div class="footer" style="margin:0 auto">
                <div class="wrap">
                    <div class="footer-in">

                        <div class="footer-navs">
                            <a href="/" class="fn-index">首页</a><b>|</b>
                            <a href="/" class="fn-diamond">在线浏览</a><b>|</b>
                                <a href="/" class="fn-login">联系我们</a>
                                                    </div>

                    </div>
                </div>
            </div>





  </div>
</template>

<script>
 // 引入公共的bug，来做为中间传达的工具
  import Bus from './bus.js'

export default {
  name: 'search',
  data(){
  return {
    token:localStorage.authorization,
    level:0,
    excel: '' ,
    tips:'',
    hl:'',
    mhl:'',
    size_from: '0.3' ,
    size_to:'1.5',
    shape:'Round',
    color:[],
    cut:[],
    polish:[],
    sym:[],
    flour:[],
    lab:[],
    clarity:[],
    type:[],
  cart_url:'https://www.giazh.com/auth/cart/add',
  url:'',
    diamonds:[],
    bod:[],
    diamonds2:null,
    checkedNames: [],
    cartnum:0,
  username:'',
  userinfo:{'level':0,'download':0},
   list: [],
   now_item: '',
   current_index: 0,
   list_param: {page: 1},
   no_data: false,
   has_log: 0,
   page:1,
   order:''
  }
  },
  methods:{
    sortBy(type) {
            // 这里实现按重量排序的逻辑
            if(type === 'weight') {
                // 设置排序方式
                this.order = this.order === 'asc' ? 'desc' : 'asc';
                // 调用search函数并传递排序参数
                this.search({sortField: 'weight', sortOrder: this.order});
            }
        },
    updateSizeInputs() {
        const [from, to] = this.size_range.split('-')
        this.size_from = from
        this.size_to = to
    },
    format: function(value) {
              return  Math.round(value * 100) / 100;
            },
    elementByValue: function () {
        Bus.$emit('val', this.cartnum)
      },
      elementByValue2: function () {
  Bus.$emit('val2', this.user_info)
      },
            getUserInfo: function () {
          this.$http.post('https://www.giazh.com/auth/user/userinfo',{},{ headers: {'Authorization': this.token},emulateJSON:true}).then((data)=>{
      console.log('2222',data);
      this.userinfo=data.body;
      this.elementByValue2();
        console.log('data.body.level',data.body.level);
       if(this.userinfo.level<1) {
        this.tips='当前用户等级无法查看价格请联系客服审核升级会员';
       } 
     
      }).catch(err => {
        console.log(err);
        localStorage.clear();
        //alert('已退出');
        //window.location.reload(true);
            });
    }
  ,

   onScroll () {
   //console.log("aaaaaaaaaaaaaaaaaaa");
   let scrollTop = document.documentElement.scrollTop;
      let windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
      let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
   if (scrollTop + windowHeight + 100 >= scrollHeight ) {
    //console.log("bbbbbbbbbbbbbbb");
            
            //let that = this;
            //setTimeout(function(){
            //},300);
            //console.log('nexturl',this.bod.next_page_url);
            //console.log('thisurl',this.url);
            if(this.bod.next_page_url!=this.url){
              this.url = this.bod.next_page_url;
              this.search2();
            }          
   
   }
  },

   getCartNum: function () {
          this.$http.post('https://www.giazh.com/auth/cart/cartnum',{},{ headers: {'Authorization': this.token},emulateJSON:true}).then((data)=>{
      console.log('2222',data);
      this.cartnum=data.body;
      this.elementByValue();
     
      }).catch(err => {
        console.log(err);
        localStorage.clear();
        //alert('已退出');
        //window.location.reload(true);
            });
    },
            setShape: function(value) {
              if(value==this.shape&&this.shape!=''){
                   this.shape='';
              } else{
                  this.shape=value;
              }
              
              console.log(this.shape);

            },
            setColor: function(value) {
                if(this.color.indexOf(value)>-1){
                  this.color.splice( this.color.indexOf(value),1 );
                } else{                 
                  this.color.push(value);
                  $.unique(this.color);
                }
                console.log(this.color);              
            },
            setClarity: function(value) {
              if(this.clarity.indexOf(value)>-1){
                  this.clarity.splice( this.clarity.indexOf(value),1 );
                } else{                 
                  this.clarity.push(value);
                  $.unique(this.clarity);
                }              
              console.log(this.clarity);
            },
            setCut: function(value) {
              if(this.cut.indexOf(value)>-1){
                  this.cut.splice( this.cut.indexOf(value),1 );
                } else{                 
                  this.cut.push(value);
                  $.unique(this.cut);
                }             
              console.log(this.cut);
            },
            setPolish: function(value) {
              if(this.polish.indexOf(value)>-1){
                  this.polish.splice( this.polish.indexOf(value),1 );
                } else{                 
                  this.polish.push(value);
                  $.unique(this.polish);
                } 
              
              console.log(this.polish);

            },
            setSym: function(value) {
              if(this.sym.indexOf(value)>-1){
                  this.sym.splice( this.sym.indexOf(value),1 );
                } else{                 
                  this.sym.push(value);
                  $.unique(this.sym);
                }
              
              console.log(this.sym);

            },
            setFlour: function(value) {
              if(this.flour.indexOf(value)>-1){
                  this.flour.splice( this.flour.indexOf(value),1 );
                  if(value=='N') {
                   this.flour.splice( this.flour.indexOf('N'),1 );
                   this.flour.splice( this.flour.indexOf('NN'),1 ); 
                   this.flour.splice( this.flour.indexOf('NON'),1 ); 
                   this.flour.splice( this.flour.indexOf('NONE'),1 ); 
                   this.flour.splice( this.flour.indexOf('N'),1 );  
                  } 
                  if(value=='F') {
                    this.flour.splice( this.flour.indexOf('F'),1 );
                   this.flour.splice( this.flour.indexOf('FA'),1 ); 
                   this.flour.splice( this.flour.indexOf('Faint'),1 ); 
                   this.flour.splice( this.flour.indexOf('FNT'),1 );  
                  }
                  if(value=='M') {
                    this.flour.splice( this.flour.indexOf('M'),1 );
                   this.flour.splice( this.flour.indexOf('ME'),1 ); 
                   this.flour.splice( this.flour.indexOf('MED'),1 ); 
                   this.flour.splice( this.flour.indexOf('Medium'),1 ); 
                  }
                  if(value=='S') {
                     this.flour.splice( this.flour.indexOf('S'),1 );
                     this.flour.splice( this.flour.indexOf('SB'),1 ); 
                     this.flour.splice( this.flour.indexOf('ST'),1 ); 
                     this.flour.splice( this.flour.indexOf('STG'),1 );
                     this.flour.splice( this.flour.indexOf('Strong'),1 );
                  }
                  if(value=='VS') {
                     this.flour.splice( this.flour.indexOf('VS'),1 );
                     this.flour.splice( this.flour.indexOf('VERY STRONG'),1 ); 
                  }
                } else{ 
                  if(value=='N') {this.flour.push('N','NN','NON','NONE')} 
                  if(value=='F') {this.flour.push('F','FA','Faint','FNT')}
                  if(value=='M') {this.flour.push('M','ME','MED','Medium')}
                  if(value=='S') {this.flour.push('S','SB','ST','STG','Strong')}
                  if(value=='VS') {this.flour.push('VS','VERY STRONG')}              
                  
                  $.unique(this.flour);
                }
              
              console.log(this.flour);

            },

             setType: function(value) {
                if(this.type.indexOf(value)>-1){
                  this.type.splice( this.type.indexOf(value),1 );
                } else{                 
                  this.type.push(value);
                  $.unique(this.type);
                }
                console.log(this.type);              
            },

            setLab: function(value) {
              if(this.lab.indexOf(value)>-1){
                  this.lab.splice( this.lab.indexOf(value),1 );
                } else{                 
                  this.lab.push(value);
                  $.unique(this.lab);
                }
              
              console.log(this.lab);

            },
            search: function() {
                  if(this.token){
                     this.url="https://www.giazh.com/auth/search";  
                   } else {
                     this.url="https://www.giazh.com/api/search";
                   }
                  this.diamonds = [];
                  if( !this.size_from ||  !this.size_to){
                      alert('请输入正确的重量范围');
                      return;
                  }
                  this.search2();             
            },

         search2: async function () {
                var url= this.url;
                var postData ={
                size_from:this.size_from,
                size_to:this.size_to,
                shape:this.shape,
                color:this.color,
                clarity:this.clarity,
                cut:this.cut,
                polish:this.polish,
                sym:this.sym,
                flour:this.flour,
                lab:this.lab,
                type:this.type,
                order:this.order
                }
               // console.log(postData);
               await this.$http.post(url,postData,{ headers: {'Authorization': this.token},emulateJSON:true}).then(successResponse => {
                        //console.log('cdc',successResponse);   
                        if(successResponse.status==200){
                          if(this.page > successResponse.body.last_page){
                            return false;
                          }
                         console.log(this.url);
                       // console.log('ccc',successResponse.body.data); 
                       this.bod = successResponse.body;                     
                        this.diamonds = this.diamonds.concat( successResponse.body.data ); 
                       // console.log(this.url);
                       // console.log(this.diamonds);
                          //this.hl=this.diamonds[0]['hl'];
                             // this.tips=this.diamonds[0]['tips'];

                          

                         
                        }

                  }).catch(err => {
                    console.log(err);
                });
         },
         addCart: function(diamond,id) {

        this.$http.post(this.cart_url,{goods_id:id},{ headers: {'Authorization': this.token},emulateJSON:true}).then((data)=>{
      console.log('2222',data);
      this.getCartNum();
      diamond.cartszsh=1;
      diamond.username=this.username;
      alert('添加购物车成功,请到购物车提交订单');
      }).catch(err => {
        console.log(err);
        //localStorage.clear();
        //alert('已退出');
        //window.location.reload(true);
            });

            },

    refresh: function() {
        this.search();
        this.getCartNum();
    }
    ,
    rate: function () {
          this.$http.post('https://www.giazh.com/api/rate',{},{ headers: {'Authorization': this.token},emulateJSON:true}).then((data)=>{
      console.log('2222',data);
      this.hl=data.body;
     
      }).catch(err => {

            });
    },
    mrate: function () {
          this.$http.post('https://www.giazh.com/api/mrate',{},{ headers: {'Authorization': this.token},emulateJSON:true}).then((data)=>{
      console.log('2222',data);
      this.mhl=data.body;
     
      }).catch(err => {

            });
    }
  },
  components:{
  },
  created(){
     if(this.token){
       this.username=localStorage.username;
       this.url="https://www.giazh.com/auth/search";
       this.getUserInfo();   
     }else{
       this.url="https://www.giazh.com/api/search";
     }
      this.search();
      this.rate();
      this.mrate();

      window.addEventListener('scroll', this.onScroll);
  }
}
</script>



<style scoped>
table td{height:25px;text-align:center;color:#000;word-break: keep-all;white-space:nowrap;}
    .on {
      background: #c7eaf9;
    }
    .off {
      background: #ffffff;
    }

    table td a{color:blue}


    .xz {border:1px solid #EEEEEC;margin:10px;float:left;cursor:pointer; background-image:url(../assets/images/bg11.jpg)}
.xz_a {border:1px solid #990000;}

.ys {border:1px solid #EEEEEC;margin:2px;float:left;cursor:pointer;background-image:url(../assets/images/bg11.jpg); width:42px; height:42px;}
.ys_a {border:1px solid #990000;}

.jd {border:1px solid #EEEEEC;margin:10px;float:left;cursor:pointer;background-image:url(../assets/images/bg11.jpg)}
.jd_a {border:1px solid #990000;}


.btn-primary {
    color: #fff;
    background-color: #0085c8;
    border-color: #d43f3a;
}
.btn {
    display: inline-block;
    padding: 6px 12px;
    margin-bottom: 0;
    font-size: 14px;
    font-weight: 400;
    line-height: 1.42857143;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
    -ms-touch-action: manipulation;
    touch-action: manipulation;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-image: none;
    border: 1px solid transparent;
    border-radius: 4px;
}

  .badge {
      display: inline-block;
      min-width: 10px;
      padding: 3px 7px;
      font-size: 12px;
      font-weight: 700;
      line-height: 1;
      color: #fff;
      text-align: center;
      white-space: nowrap;
      vertical-align: middle;
      background-color: #777;
      border-radius: 10px;
     }

</style>


// WEBPACK FOOTER //
// src/components/Search.vue